import {
  CancelDialogActions,
  ImageCancelDialogLayout,
  CancelModal,
  CancelDialogMessageLayout,
} from '@Components/shared/dialogs/CancelDialog';
import { useCreateProviderConfig } from '@Modal/hooks/providers/useCreateProviderConfig';

export const CreateProviderConfigCancelModalDialog: React.FC = () => {
  const { handleCancelTakeMeBack, showCancelProviderConfigForm } = useCreateProviderConfig();

  return (
    <>
      {showCancelProviderConfigForm && (
        <CancelModal open={showCancelProviderConfigForm}>
          <ImageCancelDialogLayout
            title="Cancel provider config?"
            actions={
              <CancelDialogActions
                onReject={() => handleCancelTakeMeBack('back')}
                onConfirm={() => handleCancelTakeMeBack('')}
              />
            }
          >
            <CancelDialogMessageLayout>
              You are about to delete all the changes you have made in provider config settings
            </CancelDialogMessageLayout>
          </ImageCancelDialogLayout>
        </CancelModal>
      )}
    </>
  );
};
